import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { deviceRowQuery } from '../api/softsee'
import { DeviceWorkspace } from '../devices/DeviceWorkspace'
import { Content } from '../ui/Shell'
import { DataTable, useTableState } from '../ui/DataTable'
import { Spinner } from '../ui/Spinner'
import { deviceColumns, type DeviceRow } from './columns'

/**
 * Fisa standalone - Softsee::device. Fara id: "Device is undefined".
 * Cu id: tabelul si fisa deschisa, ca expandTable dupa load.
 */

export function DevicePage({ id }: { id: string | undefined }) {
  const deviceId = Number(id)
  if (!id || !Number.isFinite(deviceId) || deviceId < 1) {
    return (
      <Content>
        <div className="notifications">
          <div className="alert alert-danger">
            <i className="fas fa-info-circle"></i> Device is undefined
          </div>
        </div>
      </Content>
    )
  }

  return <StandaloneDevice id={deviceId} />
}

function StandaloneDevice({ id }: { id: number }) {
  /*
   * Fara desfasurator si fara bifa: fisa e deja deschisa dedesubt, iar bifa
   * hraneste widgetul statiilor alese, care pe o singura statie n-are ce
   * intreba. Doua butoane care nu fac nimic sunt mai rele decat lipsa lor.
   */
  const columns = useMemo(() => deviceColumns().filter((c) => c.index !== 0 && c.index !== 12), [])
  const [state, setState] = useTableState('softseeDevice', { start: 0, length: 25, order: { column: 2, dir: 'desc' }, search: '' })
  const query = useQuery(deviceRowQuery(id))

  if (query.isPending) {
    return (
      <Content>
        <Spinner />
      </Content>
    )
  }
  if (query.isError) {
    return (
      <Content>
        <div className="alert alert-danger" role="alert">
          Something went wrong: {(query.error as Error).message}
        </div>
      </Content>
    )
  }

  const row = query.data as DeviceRow
  return (
    <Content>
      <div className="deviceTable">
        <DataTable
          id="softseeDevice"
          columnTools
          columns={columns}
          rows={[row]}
          total={1}
          fetching={query.isFetching}
          error={null}
          onRetry={() => void query.refetch()}
          state={state}
          onState={setState}
          rowId={(r) => String(r.DT_RowId)}
        />
        <DeviceWorkspace id={id} from="softsee" />
      </div>
    </Content>
  )
}
